




























































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'form', 'meta',
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      client_id: { required },
      person_id: {  },
      delivery_point_id: {  },
      weekday: {  },
      is_strict: {  },
      with_address: {  },
      with_saturday: {  },
      with_monday: {  },
    }

    return {
      form: rules
    }
  }
})
export default class ClientDealsSchedulingForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any
  form!: any

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  getAsyncData(name: any){
    if (!name.length) {
        this.suggestions = [];
        return;
    }
    this.isSuggestionsFetching = true;
    
    (this as any).$http
      .post(`/api/v1/dadata/suggestions/api/4_1/rs/suggest/party`, JSON.stringify({ "query": name }))
        .then(({ data }: any) => {
          this.$set(this, 'suggestions', data.suggestions);
        })
        .catch((error: any) => {
            this.suggestions = [];
            throw error
        })
        .finally(() => {
            this.isSuggestionsFetching = false
        })  
  }

  getAsyncDataDebounce = debounce(this.getAsyncData, 500)

  initFromSuggestion({ value, data, unrestricted_value }: any) {
    this.changeValue('name', value);
    this.changeValue('inn', data.inn);
    this.changeValue('kpp', data.kpp);
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

setArchive() {
  this.$store.dispatch(`${STORE_KEY}/setArchive`)
  .then((result) => {
      this.$buefy.snackbar.open(`Записть архивирована`);

      this.$emit('form-close');
      (this.$parent as any).close();
    })
    .catch((e) => {
      console.log(e)
      this.$buefy.snackbar.open({
        type: 'is-warning',
        message: `При сохранении возникли проблемы. Попробуйте позже.`
      })
    })
}

setUnarchive() {
  this.$store.dispatch(`${STORE_KEY}/setUnarchive`)
  .then((result) => {
      this.$buefy.snackbar.open(`Записть активирована`);

      this.$emit('form-close');
      (this.$parent as any).close();
    })
    .catch((e) => {
      console.log(e)
      this.$buefy.snackbar.open({
        type: 'is-warning',
        message: `При сохранении возникли проблемы. Попробуйте позже.`
      })
    })    
}

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

